export default {
  PRESENCE: 'PRESENCE',
  PATTERN: 'PATTERN',
  CUSTOM: 'CUSTOM',
};



// WEBPACK FOOTER //
// ./constants/validationErrorTypes.js